export default {
  name: '',
  acronym: '',
  isActive: true
};
